<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCInvestment :h2="this.h2" :h3="this.h3">
      <template v-slot:copy>
        <div>
          <div>
            <div class="investment-element margin-bottom">
              <div>
                <p class="uppercase">Section W1 + W9</p>
                <div class="pad">
                  <p class="small">per season membership</p>
                  <div class="price-per-year">{{seats * price0 | toCurrency}}</div>
                </div>
              </div>
              <div class="map">
                <img
                  src="~@/assets/maps/reserve-cincinnatus-1.png"
                  alt
                  data-aos="zoom-in-up"
                  data-aos-duration="250"
                  data-aos-easing="ease-out-cubic"
                />
              </div>
            </div>
            <div class="investment-element margin-bottom">
              <div>
                <p class="uppercase">Section W2, W3, W7, W8</p>
                <div class="pad">
                  <p class="small">per season membership</p>
                  <div class="price-per-year">{{seats * price1 | toCurrency}}</div>
                </div>
              </div>
              <div class="map">
                <img
                  src="~@/assets/maps/reserve-cincinnatus-2.png"
                  alt
                  data-aos="zoom-in-up"
                  data-aos-duration="250"
                  data-aos-easing="ease-out-cubic"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="text-center margin-top">
          <a href="#">
            <FCButtonCTA text="Sold Out" />
          </a>
          <p
            class="uppercase"
          >To be added to the Pitchview/Cincinnatus/First Financial Club waitlist, please call 513-977-5435.</p>
        </div>
      </template>
    </FCInvestment>
  </div>
</template>

<script>
/*
<a
            target="_blank"
            href="https://deposits.fccincinnati.com/events/2021 club deposit/2020-12-31_19.30/fc cincinnati deposits"
            @click="$gtag.event('begin_checkout', {'event_label': 'Cincinnatus Club'})"
          >
            <FCButtonCTA text="Claim your place" />
          </a>
          <p class="uppercase">Make your $100 deposit here</p>
          
<div class="seats-multiplier text-center">
              <p class="uppercase"># of seats</p>
              <div class="controls">
                <button @click="changeSeats(-1)">-</button>
                <div class="value">{{seats}}</div>
                <button @click="changeSeats(1)">+</button>
              </div>
            </div>
*/
import FCInvestment from "@/components/patterns/FCInvestment";
import FCButtonCTA from "@/components/patterns/FCButtonCTA";
export default {
  components: {
    FCInvestment,
    FCButtonCTA,
  },
  filters: {
    toCurrency: function (value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
  mounted() {
    const ref = this.$store.state.menu.cincinnatusClub.ref;
    const index = this.$store.state.menu.menuItems
      .map((e) => e.ref)
      .indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.cincinnatusClub.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.cincinnatusClub.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "Cincinnatus Club",
      h3: "Reserve Yours",
      seats: 1,
      price0: 1700,
      price1: 1900,
    };
  },
  methods: {
    changeSeats(_modifier) {
      let _currentValue = this.seats;
      this.seats = Math.max(1, _currentValue + _modifier);
    },
  },
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-cincinnatus-intro.jpg");
  background-size: cover;
  background-position: center;
}
</style>